module.exports = __webpack_public_path__ + "img/bfc-logo.03a01f9f.png";